import React from 'react';


const ThreeOptions = props => {
    return (
        <div className="form-group">
            <label htmlFor={props.name}>{props.label}</label>
            <div>
                <select id={props.name} name={props.name} required="required" className="custom-select">
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                    <option value="NA">N/A</option>
                </select>
            </div>
        </div>
    );
}

export default ThreeOptions;


// WEBPACK FOOTER //
// ./src/components/ThreeOptions.js